// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__vpoxk","title":"Images90_title__iGePJ","images":"Images90_images__3izSh"};